// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__39YXR","boxTitle":"Qualiphy_boxTitle__kqaU4","box":"Qualiphy_box__2sogS","toggleWrap":"Qualiphy_toggleWrap__PYcaA"};